export default function BenefitsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Une vraie économie locale et solidaire
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Localygo n'est pas une multinationale. C'est votre plateforme, créée pour les habitants de votre ville, qui met en avant vos commerçants de quartier et crée des emplois locaux pour les livreurs indépendants.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mr-4 flex-shrink-0">
                  <i className="ri-store-3-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Soutenez vos commerçants
                  </h3>
                  <p className="text-sm text-gray-600">
                    Chaque commande aide directement les restaurants et boutiques de votre quartier à prospérer et maintenir leur activité locale.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mr-4 flex-shrink-0">
                  <i className="ri-team-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Créez des emplois locaux
                  </h3>
                  <p className="text-sm text-gray-600">
                    Nos livreurs sont des habitants de votre ville qui complètent leurs revenus de manière flexible en livrant dans leur propre quartier.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mr-4 flex-shrink-0">
                  <i className="ri-earth-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    Réduisez votre empreinte
                  </h3>
                  <p className="text-sm text-gray-600">
                    Des livraisons courtes distances avec Localygo uniquement, pour minimiser l'impact environnemental tout en soutenant le circuit court.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative w-full h-96 lg:h-full min-h-[500px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/39984b842bbfbfc0572a1e9d0653502e.jpg"
              alt="Économie locale Localygo"
              className="w-full h-full object-cover object-top rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
